export const htmlStringParser = (data?: string | null) => {
  if (!data) return ''

  const parse = new DOMParser().parseFromString(data, 'text/html')

  return parse.body.textContent || ''
}
